import {useEffect, useState} from "react"
import {createBrowserRouter, NavigationType, useNavigate, useParams} from "react-router-dom"

import "./Shop.css"
import closeBtn from "../../assets/mobileClose.svg"
import itemDelete from "../../assets/itemDelete.svg"

import Nav from "../../component/Nav/Nav"
import Footer from "../../component/Footer/Footer"
import SubBanner from "../../component/SubBanner/SubBanner"
import ShopProgress from "../../component/Shop/ShopProgress"
import ItemCheck from "../../component/Shop/ItemCheck"
import InfoCheck from "../../component/Shop/InfoCheck"
import OrderPay from "../../component/Shop/OrderPay"
import OrderComplete from "../../component/Shop/OrderComplete"
import {numberWithCommas, retrieveData, sendRequest, storeData, validatePhone} from "../../common";


const Product = ({product, onSave, user}) => {

	const [quantity, setQuantity] = useState(0)

	


	return (
		<tr>
			<td>
				<div className="itemName" style={{whiteSpace: 'pre-wrap'}}>
					<span>【{product?.group}】 {product?.name}</span>
					{product?.desc}
				</div>
			</td>
			<td className="itemPrice">{numberWithCommas(product.price)}원</td>
			<td>
				<span className="itemQty">
					<input type="text" maxLength={8} name="qty" placeholder="0" required value={quantity} onChange={e => {
						
						// if(product.discount_rate != 0){
						// 	alert(1);
						// }
						// if (!validatePhone(e.target.value, setQuantity)) return
						// if (e.target.value?.length > 8) return
						// console.log(e.target.value.replace(/[^\d]/,''))
						setQuantity(e.target.value.replace(/[^\d]/,''))
					}}/>
				</span>
			</td>
			<td className="orderPrice">{numberWithCommas(product.price * quantity)}원</td>
			<td className="itemTax">{!product?.vat ? '면세' : numberWithCommas(product.vat) + '원'}</td>
			<td className="itemCart">
				<button type="button" onClick={() => quantity && onSave(product, quantity)}>담기</button>
			</td>
		</tr>
	)
}


function Purchase({}) {

	const navigate = useNavigate()
	const queryParameters = new URLSearchParams(window.location.search)
	const initStep = queryParameters.get("step")
	const imp_success = queryParameters.get("imp_success")
	const orderNumber = queryParameters.get("orderNumber")

	const [step, setStep] = useState((imp_success?.toString() === 'true' && initStep) ? parseInt(initStep) : 0)
	const [user, setUser] = useState({})
	const [products, setProducts] = useState([])
	const [orderProducts, setOrderProducts] = useState([])

	useEffect(() => {
		if (imp_success?.toString() === 'true') {
			sendRequest(`order/order/?orderNumber=${orderNumber}`, 'GET', null, data => {
				const order = data.pop()
				sendRequest(`order/order/${order?.id}/`, 'PUT', {
					status: '결제완료'
				})
			})
		}
	}, [orderNumber, imp_success])

	useEffect(() => {
		window.history.pushState(null, null, window.location.href);
		window.onpopstate = function(event) {
			if (step > 0) {
				setStep(step - 1)
			} else {
				// navigate(-1)
				// window.history.go(1);
			}

		};
	}, [step])

	// const getProducts = () => {
	// 	sendRequest('product/product/?page=1&size=100', 'GET', null, (data, page) => {

	// 		  // user의 certificate를 기준으로 discount 적용
	// 		  const updatedProducts = data.map(prod => {
	// 			const certificate = user?.certificates?.find(cert =>
	// 			  cert.certificateType?.products?.some(p => p.id === prod.id)
	// 			);
		  
	// 			const discountRate = certificate?.certificateType?.discount_rate ?? 0;
		  
	// 			return {
	// 			  ...prod,
	// 			  original_price: prod.price,
	// 			  price: Math.round(prod.price * (1 - discountRate / 100)),
	// 			  discount_rate: discountRate
	// 			};
	// 		  });
		  
	// 		  setProducts(updatedProducts);
	// 		  //setProducts(data)
	// 		});
	// }

	// const getUserDetail = (id) => {
	// 	sendRequest(`accounts/user/${id}/`, 'GET', null, data => {
	// 		setUser(data)
	// 	})
	// }

// const getUserDetail = (id) => {
//   sendRequest(`accounts/user/${id}/`, 'GET', null, (data) => {
//     // certificateType 안의 products 가격에 할인율 적용
//     const updatedCertificates = data.certificates?.map(cert => {
//       const discountRate = cert.certificateType?.discount_rate ?? 0;

//       const updatedProducts = cert.certificateType?.products?.map(prod => ({
//         ...prod,
//         original_price: prod.price, // 원래 가격 보존
//         price: Math.round(prod.price * (1 - discountRate / 100)), // 할인된 가격으로 교체
//         discount_rate: discountRate
//       }));

//       return {
//         ...cert,
//         certificateType: {
//           ...cert.certificateType,
//           products: updatedProducts
//         }
//       };
//     });

//     const updatedUser = {
//       ...data,
//       certificates: updatedCertificates
//     };

//     setUser(updatedUser);
//   });
// };



	// useEffect(() => {
	// 	retrieveData('user').then(user => {
	// 		getUserDetail(user?.id)
	// 		if (!user || !user?.isExpert) {
	// 			alert('전문가 회원만 볼 수 있습니다.')
	// 			navigate('/')
	// 			return
	// 		}
	// 	})
	// 	getProducts()
	// }, [])

	useEffect(() => {
		const fetchUserAndProducts = async () => {
		  try {
			const storedUser = await retrieveData('user');
			
			if (!storedUser || !storedUser?.isExpert) {
			  alert('전문가 회원만 볼 수 있습니다.');
			  navigate('/');
			  return;
			}
	  
			// 1. 유저 상세 정보 가져오기
			const userData = await new Promise((resolve, reject) => {
			  sendRequest(`accounts/user/${storedUser.id}/`, 'GET', null, resolve, reject);
			});
	  
			// 2. certificateType 안의 products에 할인율 적용
			const updatedCertificates = userData.certificates?.map(cert => {
			  const discountRate = cert.certificateType?.discount_rate ?? 0;
	  
			  const updatedProducts = cert.certificateType?.products?.map(prod => ({
				...prod,
				original_price: prod.price, // 원래 가격 보존
				price: Math.round(prod.price * (1 - discountRate / 100)), // 할인 적용
				discount_rate: discountRate
			  }));
	  
			  return {
				...cert,
				certificateType: {
				  ...cert.certificateType,
				  products: updatedProducts
				}
			  };
			});
	  
			const updatedUser = { ...userData, certificates: updatedCertificates };
			setUser(updatedUser);
	  
			// 3. products 가져오기
			const productsData = await new Promise((resolve, reject) => {
			  sendRequest('product/product/?page=1&size=100', 'GET', null, resolve, reject);
			});
	  
			// 4. 가져온 products에 유저 할인 적용
			const updatedProducts = productsData.map(prod => {
				// 해당 product를 포함하는 모든 certificate 찾기
				const matchedCertificates = updatedUser.certificates?.filter(cert =>
				cert.certificateType?.products?.some(p => p.id === prod.id)
				) || [];
			
				// 가장 높은 할인율 찾기
				const maxDiscountRate = matchedCertificates.reduce((max, cert) => {
				const rate = cert.certificateType?.discount_rate ?? 0;
				return rate > max ? rate : max;
				}, 0);
			
				return {
				...prod,
				original_price: prod.price,
				price: Math.round(prod.price * (1 - maxDiscountRate / 100)),
				discount_rate: maxDiscountRate
				};
			});
  

			// // 4. 가져온 products에 유저 할인 적용
			// const updatedProducts = productsData.map(prod => {
			//   const certificate = updatedUser.certificates?.find(cert =>
			// 	cert.certificateType?.products?.some(p => p.id === prod.id)
			//   );
	  
			//   const discountRate = certificate?.certificateType?.discount_rate ?? 0;
	  
			//   return {
			// 	...prod,
			// 	original_price: prod.price,
			// 	price: Math.round(prod.price * (1 - discountRate / 100)),
			// 	discount_rate: discountRate
			//   };
			// });
	  
			setProducts(updatedProducts);
		  } catch (error) {
			console.error(error);
		  }
		};
	  
		fetchUserAndProducts();
	  }, []);

	const [notiOpen, setNotiOpen] = useState(false)
	const showNoti = () => {
		setNotiOpen(true)
	}
	const closeNoti = () => {
		setNotiOpen(false)
	}

	// const onSave = (product, quantity) => {
		
	// 	const prevIndex = orderProducts.findIndex(item => item.product.id === product?.id);

	// 	// user certificate 안에 있는 product인지 확인
	// 	const certificate = user.certificates?.find(cert =>
	// 		cert.certificateType.products?.some(p => p.id === product.id)
	// 	);

	// 	// 해당 certificate의 discount_rate
	// 	const discountRate = certificate?.certificateType?.discount_rate ?? 0;

	// 	if (prevIndex !== -1) {
	// 		// 수량 누적
	// 		orderProducts[prevIndex].quantity += parseInt(quantity);

	// 		// product 안에 discountRate만 저장
	// 		orderProducts[prevIndex].product = {
	// 			...orderProducts[prevIndex].product,
	// 			discountRate: discountRate
	// 		};
	// 	} else {
	// 		orderProducts.push({
	// 			product: {
	// 				...product,
	// 				discountRate: discountRate
	// 			},
	// 			quantity: parseInt(quantity)
	// 		});
	// 	}
	// 	setOrderProducts(Object.assign([], orderProducts))
	// }

	const onSave = (product, quantity) => {
		const prevIndex = orderProducts.findIndex(item => item.product.id === product?.id);
	  
		if (prevIndex !== -1) {
		  // 수량 누적
		  orderProducts[prevIndex].quantity += parseInt(quantity);
		} else {
		  orderProducts.push({
			product,
			quantity: parseInt(quantity)
		  });
		}
	  
		// React가 상태 변경 감지할 수 있게 새 배열로 업데이트
		setOrderProducts([...orderProducts]);
	  };

	const onDelete = (index) => {
		orderProducts.splice(index, 1)
		setOrderProducts(Object.assign([], orderProducts))
	}

	
	//const totalPrice = orderProducts?.map(item => (item?.product?.price + item?.product?.vat ?? 0) * item?.quantity).reduce((prev, curr) => prev + curr, 0)
	const totalPrice = orderProducts
  ?.map(item => {
	// const certificate = user.certificates?.find(cert =>
	// 	cert.certificateType.products?.some(p => p.id === item.product.id)
	// );
	// 	// 해당 certificate의 discount_rate
	// 	const discountRate = certificate?.certificateType?.discount_rate ?? 0;

	// 	// 최종 가격 계산
	// 	const discountedPrice = item.product.price * (1 - discountRate / 100);

    const vat = item.product.vat ?? 0
	//numberWithCommas(Math.round(discountedPrice * item?.quantity))
    return (item.product.price + vat) * item.quantity
  })
  .reduce((prev, curr) => prev + curr, 0)

	return ( user?.id && user?.isExpert &&
		<>
			<Nav user={user} />
			<SubBanner title={"구매하기"} firstText={"온라인 구매 후"} lastText={"다양한 서비스를 경험해보세요."} />
			<div className="container">
				{step === 0 ?
					<div className="itemSelect">
						<form name="itemSelect">
							<section className="leftCard">
								<ShopProgress isFirst={true}/>
								<div className="shopTableWrap">
									<table className="shopTable">
										<colgroup>
											<col width="40%"/>
											<col width="15%"/>
											<col width="10%"/>
											<col width="15%"/>
											<col width="10%"/>
											<col width="10%"/>
										</colgroup>
										<thead>
										<tr>
											<th>상품명</th>
											<th>금액</th>
											<th>수량</th>
											<th>주문금액</th>
											<th>부가세</th>
											<th>장바구니</th>
										</tr>
										</thead>
										<tbody>
										{products?.map((item, index) => {
											return (
												<Product  key={item.id} product={item} onSave={onSave} user={user}/>
											)
										})}
										</tbody>
									</table>
									<div style={{fontSize: 14, marginTop: 10}}>
										※ 단체검사는 집단의 다수 구성원들이 검사하는 방식이며, 검사시행하는 총 인원만큼 수량을 체크해서 구매해주시길 바랍니다.
									</div>
									<div style={{fontSize: 14, marginTop: 10}}>
										※ 서비스 제공기간은 구입한 시점으로부터 1년 이내입니다.
									</div>
								</div>
							</section>
							<section className="rightCard">
								<h4>결제 목록</h4>
								<div className="orderWrap">
									<ul className="orderList">
										{orderProducts.map((item, index) => {
											//할인율 적용
											// user certificate 안에 있는 product인지 확인
											// const certificate = user.certificates?.find(cert =>
											// 	cert.certificateType.products?.some(p => p.id === item.product.id)
											// );

											// // 해당 certificate의 discount_rate
											// const discountRate = certificate?.certificateType?.discount_rate ?? 0;

											// // 최종 가격 계산
											// const discountedPrice = item.product.price * (1 - discountRate / 100);
											//const discountRate = item?.product?.certificateType?.discount_rate ?? 0;
											//const price = item.product.price * (1 - discountRate / 100);
											//const discountRate = item?.product?.discount_rate ?? 0;
											//const price = item.product.price * (1 - discountRate / 100);
											return (
												<li style={{marginBottom: 20}}>
													<div className="orderItem">
														<div>
															<span>【{item?.product?.group}】 {item?.product?.name}</span>
															{item?.product?.desc}
														</div>
														<button type="button" onClick={() => onDelete(index)}>
															<img src={itemDelete} alt="품목 삭제"/>
														</button>
													</div>
													<div className="orderInfo">
														{item?.quantity}개
														<span>{numberWithCommas(Math.round(item.product.price * item?.quantity))}원</span>
													</div>
												</li>
											)
										})}
									</ul>
									<div className="total">
										<span>합계</span>
										<span className="price">{numberWithCommas(totalPrice)}원</span>
									</div>
								</div>
								<div className="nextBtn">
									<button type="submit" onClick={(e) => {
										e.preventDefault()
										if (!user?.isExpert) {
											showNoti()
										} else if (!orderProducts?.length) {
											alert('주문할 상품을 담아 주세요.')
										} else {
											setStep(1)
										}
									}}>
										다음 단계로 이동
									</button>
								</div>
							</section>
						</form>
					</div>
					:
					
					step === 1 ?
						<ItemCheck orderProducts={orderProducts} setOrderProducts={setOrderProducts} setStep={setStep}/>
						:
					step === 2 ?
						<InfoCheck user={user} setStep={setStep}/>
						:
					step === 3 ?
						<OrderPay orderProducts={orderProducts} user={user} setStep={setStep} imp_success={imp_success}/>
						:
					step === 4 ?
						<OrderComplete user={user} />
						:
					null
				}
			</div>

			{notiOpen && (
				<div className="notiWrap">
					<div className="notiModal">
						<div className="modalHeader">
							<h2>알림</h2>
							<button type="button" onClick={closeNoti}>
								<img src={closeBtn} alt="팝업 닫기" />
							</button>
						</div>
						<div className="modalText">
							본 검사는 <span className="blue">전문가 회원</span>만 구매하기 가능하며 <br />
							<span className="mint">일반회원</span>은 심리검사 시행 및 분석의뢰만 가능합니다.
						</div>
						<div className="modalBtn">
							<button
								type="button"
								onClick={() => {
									navigate("/inquire")
								}}>
								문의하기
							</button>
						</div>
					</div>
				</div>
			)}

			<Footer />
		</>
	)
}

export default Purchase
